module.exports = __webpack_public_path__ + "static/media/1.5b2f8c80.JPG";